import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSwitch,{staticClass:"tema-eixo-combo",attrs:{"id":"temas-select","disabled":_vm.disabled},on:{"change":function($event){return _vm.$emit('onChange')}},model:{value:(_vm.editValue[_vm.value]),callback:function ($$v) {_vm.$set(_vm.editValue, _vm.value, $$v)},expression:"editValue[value]"}})
}
var staticRenderFns = []

export { render, staticRenderFns }